<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">

          <el-form-item label="操作用户：">
            <el-input v-model="query.operatedName" placeholder="请输入操作用户" clearable size="small" />
          </el-form-item>
          <el-form-item label="访问模块：" v-if="isShow">
            <el-select v-model="query.type" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="商品信息" :value="1"></el-option>
              <el-option label="客户信息" :value="2"></el-option>
              <el-option label="课程分类" :value="3"></el-option>
              <el-option label="课程管理" :value="4"></el-option>
              <el-option label="情景练习" :value="5"></el-option>
              <el-option label="题目管理" :value="6"></el-option>
              <el-option label="技术管理" :value="20"></el-option>
              <el-option label="指标配置" :value="21"></el-option>
              <el-option label="预约服务" :value="22"></el-option>
              <el-option label="城市公司" :value="30"></el-option>
              <el-option label="线索管理" :value="45"></el-option>
              <el-option label="内部员工" :value="55"></el-option>
              <el-option label="讲师管理" :value="60"></el-option>
              <el-option label="会议管理" :value="70"></el-option>
              <el-option label="客服人员管理" :value="80"></el-option>
              <el-option label="常用语" :value="81"></el-option>
              <el-option label="知识库" :value="82"></el-option>
              <el-option label="猜你咨询" :value="83"></el-option>
              <el-option label="自动回复管理" :value="84"></el-option>
              <el-option label="归档管理" :value="85"></el-option>
              <el-option label="部门管理" :value="90"></el-option>
              <el-option label="基础配置" :value="100"></el-option>
              <el-option label="大客户" :value="110"></el-option>
              <el-option label="角色管理" :value="120"></el-option>
              <el-option label="营销分类配置" :value="121"></el-option>
              <el-option label="分享物料" :value="122"></el-option>
              <el-option label="技术老师宣传图" :value="123"></el-option>
              <el-option label="出库商品" :value="101"></el-option>
              <!-- REQ-2026-234328 3.4：售后单变更日志。不加这一项的话日志确实记了，
                   但筛选下拉里选不到，等于「记了但找不到」 -->
              <el-option label="售后单" :value="91"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="修改时间：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
            <el-button type="info" plain size="mini" @click="handleBack" v-if="!isShow">返回上一页</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <!-- <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">导出</el-button>
        </div>
      </div> -->
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="操作用户" prop="operatedUserPO.realName" align="center" >
          <template slot-scope="{row}">
            <span v-if="row.customerPO">{{row.customerPO.name}}</span>
            <span v-else-if="row.operatedUserPO">{{row.operatedUserPO && row.operatedUserPO.realName}}</span>
            
          </template>
        </el-table-column>
        <el-table-column label="访问模块" prop="" align="center">
          <template slot-scope="{row}">
            {{typeName(row)}}
          </template>
        </el-table-column>
        <el-table-column label="被操作对象" prop="updateTag" align="center" />
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作" align="center" fixed="right" width="260">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      dateTime: [],
      selectItems: [],
      activeName: '1',
      isShow: 0,
      otherType: 0
    }
  },
  created() {
    let { type, id, otherType } = this.$route.query;
    if (type) {
      this.query.type = +type
      this.isShow = 0
    } else {
      this.isShow = 1
    }
    if (id) this.query.typeDataId = +id
    if (otherType) this.otherType = +otherType
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    typeName(row) {
      let str = ''
      if (row.type === 1) str = '商品信息'
      if (row.type === 2) str = '客户信息'
      else if (row.type === 3) str = '课程分类'
      else if (row.type === 4) str = '课程管理'
      else if (row.type === 5) str = '情景练习'
      else if (row.type === 6) str = '题目管理'
      else if (row.type === 20) str = '技术管理'
      else if (row.type === 21) str = '指标配置'
      else if (row.type === 22) str = '预约服务'
      else if (row.type === 30) str = '城市公司'
      else if (row.type === 45) str = '线索管理'
      else if (row.type === 55 && this.otherType === 1) str = '账号管理'
      else if (row.type === 55 && !this.otherType) str = '内部员工'
      else if (row.type === 60) str = '讲师管理'
      else if (row.type === 70) str = '会议管理'
      else if (row.type === 80) str = '客服人员管理'
      else if (row.type === 81) str = '常用语'
      else if (row.type === 82) str = '知识库'
      else if (row.type === 83) str = '猜你咨询'
      else if (row.type === 84) str = '自动回复管理'
      else if (row.type === 85) str = '归档管理'
      else if (row.type === 90) str = '部门管理'
      // REQ-2026-234328 3.4：筛选下拉里早就有「售后单」，这个映射漏了 ——
      // 表现是筛得出来、列表那一列却是空白。下拉和映射是两处，加类型时必须一起加。
      else if (row.type === 91) str = '售后单'
      else if (row.type === 100) str = '基础配置'
      else if (row.type === 101) str = '出库商品'
      else if (row.type === 110) str = '大客户'
      else if (row.type === 120) str = '角色管理'
      else if (row.type === 121) str = '营销分类配置'
      else if (row.type === 122) str = '分享物料'
      else if (row.type === 123) str = '技术老师宣传图'
      else if (row.type === 130) str = '线下付款凭证审核'
      else if (row.type === 131) str = '线下充值记录修改'
      return str
    },
    handleFilter() {
      this.query.operatedName = ''
      this.dateTime = []
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined;
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined;
      this.listLoading = true
      return sysDataCompareLogApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleShow(row) {
      row.otherType = this.otherType
      this.$emit('handleShow', row, 2)
    },
    handleBack() {
      window.history.go(-1);
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
